import { useState, useCallback } from 'react';


// Service
import CashRegisterService from '../../services/cashRegisterService';

// Hooks
import useUser from "../user/useUser";
import { utils } from './utils';

const useCashRegister = () => {
    const { cashRegister, SelectCashRegister, business } = useUser();
    const [loading, setLoading] = useState(false);

    const GetTotals = useCallback(async () => {
        if (!cashRegister) return false;
        setLoading(true);
        return CashRegisterService
            .GetTotals(cashRegister.id)
            .finally(() => setLoading(false));
    }, [cashRegister])

    const createClosure = async (archingDetails, userEmail) => {
        const auxDetails = utils.GetDetails(archingDetails, business?.defaultCurrency);
        setLoading(true);
        const res = await CashRegisterService.CreateClosure(cashRegister.id, auxDetails, userEmail);
        SelectCashRegister({ ...cashRegister, lastClosure: res.closing });
        setLoading(false);
        return res;
    }

    return {
        cashRegister,
        loading,
        GetTotals,
        createClosure
    }
}

export default useCashRegister;